import React, { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
export default function About() {
  const { language } = useContext(LanguageContext);
  const text = {
    tr: {
      title: "Hakkımızda",
      intro:
        "Lale Kuruyemişçi olarak kalite, tazelik ve güveni işimizin merkezine koyuyor; geleneksel lezzetleri modern bir anlayışla sunuyoruz.",
      p1: "Lale Kuruyemişçi, İstanbul’da mahalle kültürünü yaşatan ve yılların tecrübesini günümüz beklentileriyle birleştiren köklü bir markadır. Kurulduğumuz günden bu yana hedefimiz; en taze kuruyemişleri, doğal ürünleri ve güvenilir hizmeti müşterilerimizle buluşturmaktır.",
      p2: "Ürünlerimiz günlük olarak tedarik edilmekte, hijyenik koşullarda özenle hazırlanmakta ve titiz kalite kontrol süreçlerinden geçirilmektedir. Her ürünü kendi soframıza koyacak hassasiyetle seçiyor, sizlere gönül rahatlığıyla sunuyoruz.",
      p3: "Bizim için Lale Kuruyemişçi yalnızca bir satış noktası değil; aynı zamanda bulunduğu mahallenin güvenilir bir parçasıdır. Güler yüzlü hizmet anlayışımız ve müşteri memnuniyeti odaklı yaklaşımımızla her zaman yanınızdayız.",
      slogan: "Doğallığı, lezzeti ve kaliteyi arayanlar için doğru adres",
      brand: "Lale Kuruyemişçi",
    },
    en: {
      title: "About Us",
      intro:
        "At Lale Kuruyemişçi, we place quality, freshness, and trust at the heart of our business, offering traditional flavors with a modern approach.",
      p1: "Lale Kuruyemişçi is a well-established brand in Istanbul that preserves neighborhood culture and combines years of experience with today’s expectations. Since our founding, our goal has been to bring the freshest nuts, natural products, and reliable service to our customers.",
      p2: "Our products are supplied daily, carefully prepared under hygienic conditions, and go through meticulous quality control processes. We select every product with the care we would for our own table and offer them to you with confidence.",
      p3: "For us, Lale Kuruyemişçi is not just a point of sale; it is also a trusted part of its neighborhood. With our friendly service approach and customer satisfaction focus, we are always by your side.",
      slogan:
        "The right address for those seeking naturalness, taste, and quality",
      brand: "Lale Kuruyemişçi",
    },
  };
  return (
    <section className="bg-light py-5">
      <div className="container">
        {/* Başlık */}
        <div className="text-center mb-5">
          <h1 className="fw-bold">{text[language].title}</h1>
          <p className="text-muted mt-3 col-lg-8 mx-auto">
            {text[language].intro}
          </p>
        </div>

        {/* İçerik Kartı */}
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card shadow-sm border-0">
              <div className="card-body p-4 p-md-5">
                <p>{text[language].p1}</p>

                <p>{text[language].p2}</p>

                <p>{text[language].p3}</p>

                <div className="mt-4">
                  <p className="fw-semibold mb-1">{text[language].slogan}</p>
                  <span className="fw-bold text-success fs-5">
                    {text[language].brand}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
